import axiosClient from "api/axiosClient";

export enum PromptType {
  IMPROVE_WRITING = "IMPROVE_WRITING",
  FIX_SPELLING_AND_GRAMMAR = "FIX_SPELLING_AND_GRAMMAR",
  MAKE_SHORTER = "MAKE_SHORTER",
  MAKE_LONGER = "MAKE_LONGER",
  MAKE_SOUND_MORE_PROFESSIONAL = "MAKE_SOUND_MORE_PROFESSIONAL",
  MAKE_SOUND_MORE_CASUAL = "MAKE_SOUND_MORE_CASUAL",
  MAKE_SOUND_MORE_CONFIDENT = "MAKE_SOUND_MORE_CONFIDENT",
  QUANTIFY_IMPACT = "QUANTIFY_IMPACT",
  SUGGEST_BULLET_POINTS = "SUGGEST_BULLET_POINTS",
  CUSTOM = "CUSTOM",
}

export interface DescriptionPayload {
  prompt: PromptType;
  promptText?: string;
  section: string;
  descriptions: string[];
}

export const improveDescription = async (payLoad: DescriptionPayload) => {
  try {
    const response = await axiosClient.post("api/resumes/improve", payLoad);
    return response.data;
  } catch (error: unknown) {
    throw error;
  }
};
